import React from 'react'

import { Box, Typography } from "@mui/material"
import { formatDate } from "@ui-seeker/utils"
import { dateFormatReceiver } from "@utils"


export default function disabledColumn() {

	return [{
		name: "timestampUserDisabled",
		label: "Disabling Date",
		options: {
			display: 'excluded',
			customBodyRowRender: value => formatDate(value, {
				isString: true,
				receivedFormat: dateFormatReceiver(value)
			})
		}
	}, {
		name: 'timestampUserDisabled',
		label: 'Disabled',
		options: {
			filter: false,
			customBodyRowRenderLite: value => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				<Typography>{formatDate(value, {
					receivedFormat: dateFormatReceiver(value),
					isString: true
				}) || "N/A"}</Typography>
			</Box>
		}
	}]
}